<template>
    <div class="footer__bg-custom">
        <footer class="footer">
            <div class="footer__direccion">
                <h3 class="footer__direccion-title-main">Torres Panorama</h3>
                <h4 class="footer__direccion-title-sub">Calle Paseo de la Loma de Querétaro No. 77 - Fraccionamiento Loma Dorada - C.P. 76060 Querétaro</h4>
            </div>
    
            <div class="footer__contacto">
                <h3 class="footer__contacto-heading" style="width:100%;margin-top:1rem">
                    <span class="footer__contacto-heading-main">Teléfono</span>
                    <span class="footer__contacto-heading-sub">Tel. 442 824 7322</span>
                </h3>
                <!-- <h3 class="footer__contacto-heading">
                    <span class="footer__contacto-heading-main">WhatsApp</span>
                    <span class="footer__contacto-heading-sub">+52 (443) 170 78 78</span>
                </h3> -->
            </div>
    
            <div class="footer__line">
                <div class="footer__line-left"></div>
                <div class="footer__line-right"></div>
            </div>
    
            <div class="footer__options">
                <div class="footer__options-descargas">
                    <a v-if="urlVideo" @click.prevent="openModal()" class="footer__options-descargas--btn" href="">Videos de desarrollo</a>
                    <a v-if="brochureUrl" @click.prevent="openBrochure()" class="footer__options-descargas--btn u__margin-left" href="">Descarga Brochure</a>
                </div>
                <div class="footer__options-terminos" >
                    <!-- <a @click="openTerm()"  class="footer__options-descargas--btn" href="">Términos y condiciones</a> -->
                    <span class="footer__options-descargas--txt u__margin-left">2022 Tres Marías</span>
                </div>
            </div>
    
            <div class="footer__devby">
                <span>Desarrollado por Kiritek</span>
            </div>
    
    
    
        </footer>
    
    </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
    name: "Footer",
    props: ["urlVideo", "brochureUrl"],
    data() {
        return {
            urlTerm: 'https://tresmarias.com.mx/terms',

        }
    },
    methods: {
        ...mapActions(["getToggleModal", "getUrlVide"]),
        openModal() {
            this.getUrlVide(this.urlVideo)
            this.getToggleModal();
        },
        openBrochure() {
            window.open(this.brochureUrl, "_blank")
        },
        openTerm() {
            window.open(this.urlTerm, "_self")
        },
    }
}
</script>
<style scoped>
@media (max-width:991.67px){
    .footer__options-terminos{
        width:100%;
        text-align: center;
    }
    .footer__options-descargas--txt{
        margin-left: 0;
    }
    .footer__options-descargas{
        display: none;
    }
}
</style>